mutation StopStreamPull($contentId: ID!) {
  stopStreamPull(contentId: $contentId) {
    id
    stream {
      id
      pull {
        sourceUrl
        status
        attempt
        maxAttempts
        startedAt
        finishedAt
        lastError {
          code
          message
        }
      }
    }
  }
}
